import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "6",
  viewBox: "0 0 10 6",
  width: "10",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m1.2207.5h7.5586c.2539 0 .42968.126953.52734.380859.09766.234371.05859.439451-.11719.615231l-3.77929 3.7793c-.11719.11719-.25391.17578-.41016.17578s-.29297-.05859-.41016-.17578l-3.779293-3.7793c-.175781-.17578-.214844-.38086-.117188-.615231.097657-.253906.273438-.380859.527341-.380859z" }, null, -1)
  ]))]))
}
export default { render: render }